import './App.css';
import HomePage from './HomePage';
import UpdateDetails from './UpdateDetails';
import {
  BrowserRouter as Router,
  Route,
  Switch, 
} from "react-router-dom";

const App = () =>{
  return (
    <Router>
      <Switch>
        <Route exact path="/update-details" name="updateDetails" component={UpdateDetails} />
        <Route path="/" name="home" component={HomePage} />
        <Route component={HomePage} />
      </Switch> 
    </Router>
  );
}

export default App;
